
import { BaseResource } from './../../../modules/models/base-resource';

export class ClientEmailModel extends BaseResource{

    email: string;
}
